function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(89.803922%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 8.988281 17.882812 C 4.085938 17.882812 0.0976562 13.890625 0.0976562 8.988281 C 0.0976562 4.085938 4.085938 0.0976562 8.988281 0.0976562 C 13.890625 0.0976562 17.882812 4.085938 17.882812 8.988281 C 17.882812 13.890625 13.890625 17.882812 8.988281 17.882812 Z M 8.988281 17.882812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 8.988281 11.453125 C 8.628906 11.453125 8.335938 11.171875 8.316406 10.8125 L 7.699219 4.832031 C 7.640625 4.078125 8.238281 3.4375 8.988281 3.4375 C 9.742188 3.4375 10.335938 4.078125 10.28125 4.832031 L 9.660156 10.8125 C 9.644531 11.171875 9.351562 11.453125 8.988281 11.453125 Z M 8.988281 11.453125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 10.0625 13.46875 C 10.0625 14.058594 9.582031 14.539062 8.988281 14.539062 C 8.398438 14.539062 7.917969 14.058594 7.917969 13.46875 C 7.917969 12.878906 8.398438 12.398438 8.988281 12.398438 C 9.582031 12.398438 10.0625 12.878906 10.0625 13.46875 Z M 10.0625 13.46875 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.dff75a49bbd027690443154de951811c.svg";
export { ForwardRef as ReactComponent };